//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ILabel } from '@models/ILabel';
import { standardSort } from '@utils/sortBy';

/**
 * Sort by count first, followed by label alphabetically
 *
 * @param labelsResp a list of ILabel to sort
 */
export const processLabels = (labelsResp: ILabel[]) => {
  return labelsResp.sort((itemA: ILabel, itemB: ILabel) => {
    if (itemA.count === itemB.count) {
      return itemA.label.localeCompare(itemB.label);
    } else {
      return standardSort(itemB.count, itemA.count);
    }
  });
};
